export const arrPopup0 = [
  { text: 'Задание: Проанализировать таблицу и определить, можно ли рекомендовать неизвестные мелодии Толе.', buttonTitle: 'Продолжить' },
]
export const arrPopup2 = [
  { text: 'Согласен. Мне тоже кажется, что понравится!' },
]
export const arrPopup3 = [
  { text: 'Согласен. Мне тоже кажется, что рекомендовать эту песню Толе не нужно.' },
]
export const arrPopup4 = [
  { text: 'Проверь ещё раз.' },
]
export const arrPopupChooseUser = [
  { text: 'Ого, у Егора и Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню Егора.', buttonTitle: 'Продолжить' },
]
export const arrPopupChooseUserWrong = [
  { text: 'Не уверен, что этот этот профиль похож на профиль Толи. Посмотри внимательнее.' },
]
export const nextLesson = [
  { text: 'Отлично, ты справился!', buttonTitle: 'Продолжить' },
]
